import React, { Component, ReactNode } from 'react';
import cx from 'classnames';
import { Alert } from 'antd';
import Icon from '@ant-design/icons';

import { ReactComponent as InfoIcon } from '../../../assets/info-square.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/sightx-icons/svg/alert-triangle.svg';
import { ReactComponent as SuccessIcon } from '../../../assets/sightx-icons/svg/sx-check-circle.svg';
import { ReactComponent as WarningIcon } from '../../../assets/sx-icon-exclamation-point.svg';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

import styles from './sxAlert.module.scss';

const isPlgExternalEnv = isFeatureEnabled(Features.PlgExternal3);

interface ISxAlertProps {
  icon?: React.ReactNode;
  colorForDefaultIcon?: string;
  title?: React.ReactNode;
  type?: 'success' | 'info' | 'warning' | 'error';
  subTextForTitle?: React.ReactNode;
  // use for Features.PlgExternal3
  className?: string;
  renderIcon?: () => JSX.Element;
  // end of use for Features.PlgExternal3
}

export class SxAlert extends Component<ISxAlertProps> {
  static defaultProps = {
    type: 'info'
  };

  private getIcon() {
    const { type } = this.props;
    switch (type) {
    case 'error':
      return ErrorIcon;
    case 'success':
      return SuccessIcon;
    case 'warning':
      return WarningIcon;
    default:
      return InfoIcon;
    }
  }

  private renderIcon() {
    const { renderIcon, type = '' } = this.props;
    if (isPlgExternalEnv && renderIcon) {
      return renderIcon();
    }
    return <div className={cx(styles.iconContainer, styles[type])}>
      <Icon component={this.getIcon()} />
    </div>;
  }

  private renderTitle() {
    const { title } = this.props;

    if (!title) {
      return null;
    }

    return <div className={styles.titleContainer}>
      {title}
    </div>;
  }

  render(): ReactNode {
    const {
      title,
      icon: propsIcon,
      type = 'info',
      className,
      renderIcon,
      ...remainingProps
    } = this.props;

    return <Alert
      {...remainingProps}
      icon={this.renderIcon()}
      showIcon
      message={this.renderTitle()}
      className={cx(styles.card, styles[type], styles.withIcon, styles.smallHeight, styles.closeIconOnTop, className)}
      type={type}
    />;
  }
}
